import { Component } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames/bind';
import { Dropdown } from 'react-bootstrap';
import autoBind from 'react-autobind';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp } from '@fortawesome/pro-light-svg-icons/faChevronUp';
import { faChevronDown } from '@fortawesome/pro-light-svg-icons/faChevronDown';

import {
  PAST_MAX_DATE_ERR,
  MAX_SELECT_TIME_PERIODS,
} from '../../../data/filters/filterConstants';
import { selectedPeriodValues } from '../../../data/filters/storyFilters';
import { validateMaxPeriodDate } from '../../../helpers/timeFilterHelpers';
import RoundRadioButton from '../../GeneralComponents/RoundRadioButton';
import withComponentName from '../../../decorators/withComponentName';

import Styles from '../story-filters-styles.module.scss';
import hasLeadingZeros from '../../../helpers/hasLeadingZeros';

const cx = classNames.bind(Styles);

class SelectedTimePeriod extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = {
      dropdownOpened: false,
      numberValueError: false,
      selectedPeriodValue: {
        number: 1,
        period: {
          value: 'minutes',
          name: 'Minutes',
        },
        fullPeriod: '1 minutes',
      },
    };
  }

  componentDidMount() {
    const { activeTimeFilter, selectedFilterValue } = this.props;

    if (activeTimeFilter === 'time_period') {
      const [periodValue, periodName] = selectedFilterValue.split(' ');

      this.setState({
        selectedPeriodValue: {
          number: +periodValue,
          period: {
            value: periodName,
            name: periodName.charAt(0).toUpperCase() + periodName.slice(1),
          },
          fullPeriod: selectedFilterValue,
        },
      });
    }
  }

  setNumberTimeValue(e) {
    e.persist();
    const { selectedPeriodValue } = this.state;
    const { setTimeFilter, earliestSearchDate, showButtonError } = this.props;

    const validatePastPeriod = validateMaxPeriodDate(
      +e.target.value,
      selectedPeriodValue.period.value,
      MAX_SELECT_TIME_PERIODS,
      earliestSearchDate,
    );

    if (validatePastPeriod === PAST_MAX_DATE_ERR) {
      return this.setState({
        selectedPeriodValue: {
          ...selectedPeriodValue,
        },
        showPeriodError: true,
        numberValueError: false,
      });
    }

    let numValue = e.target.value;

    if (!numValue || hasLeadingZeros(numValue)) {
      showButtonError(true);

      return this.setState({
        numberValueError: true,
        showPeriodError: false,
        selectedPeriodValue: {
          ...selectedPeriodValue,
          number: numValue,
          fullPeriod: `${numValue} ${selectedPeriodValue.period.value}`,
        },
      });
    }

    numValue = parseInt(numValue.replace(/\D/g, ''), 10);

    showButtonError(false);

    this.setState({
      selectedPeriodValue: {
        ...selectedPeriodValue,
        number: numValue,
        fullPeriod: `${numValue} ${selectedPeriodValue.period.value}`,
      },
      showPeriodError: false,
      numberValueError: false,
    }, () => setTimeFilter({
      selected_time_filter: 'time_period',
      time_period: this.state.selectedPeriodValue.fullPeriod,
      displayedName: this.state.selectedPeriodValue.fullPeriod,
    }));
  }

  setPeriodValueSelected(value, name) {
    const { selectedPeriodValue } = this.state;
    const { setTimeFilter, earliestSearchDate, showButtonError } = this.props;

    const validatePeriod = validateMaxPeriodDate(
      +selectedPeriodValue.number,
      value,
      MAX_SELECT_TIME_PERIODS,
      earliestSearchDate,
    );

    if (validatePeriod === PAST_MAX_DATE_ERR) {
      showButtonError(true);
      return this.setState({
        selectedPeriodValue: {
          ...selectedPeriodValue,
          period: {
            name,
            value,
          },
          fullPeriod: `${+selectedPeriodValue.number} ${value}`,
        },
        showPeriodError: true,
        numberValueError: false,
      });
    }

    if (!+selectedPeriodValue.number || hasLeadingZeros(selectedPeriodValue.number)) {
      showButtonError(true);

      return this.setState({
        numberValueError: true,
        showPeriodError: false,
        selectedPeriodValue: {
          ...selectedPeriodValue,
          number: +selectedPeriodValue.number,
          fullPeriod: `${+selectedPeriodValue.number} ${selectedPeriodValue.period.value}`,
        },
      });
    }

    showButtonError(false);

    this.setState({
      selectedPeriodValue: {
        ...selectedPeriodValue,
        period: {
          value,
          name,
        },
        fullPeriod: `${selectedPeriodValue.number} ${value}`,
      },
      showPeriodError: false,
      numberValueError: false,
    }, () => setTimeFilter({
      selected_time_filter: 'time_period',
      time_period: this.state.selectedPeriodValue.fullPeriod,
      displayedName: this.state.selectedPeriodValue.fullPeriod,
    }));
  }

  removeChars(e) {
    if (
      e.keyCode === 69
      || e.keyCode === 189
      || e.keyCode === 187
    ) {
      e.preventDefault();
    }
  }

  toggleDropdown() {
    const { dropdownOpened } = this.state;

    this.setState({ dropdownOpened: !dropdownOpened });
  }

  render() {
    const {
      dropdownOpened, selectedPeriodValue, showPeriodError, numberValueError,
    } = this.state;
    const {
      setTimeFilter, activeTimeFilter, customTimeFilter, hasBigScreenDesign, silver,
    } = this.props;

    const selectedClass = cx({
      'time-filter-item': true,
      'selected-time-filter': true,
      active: activeTimeFilter === 'time_period',
      'error-visible': showPeriodError,
    });

    return (
      <div className={selectedClass}>
        <div className={Styles['round-button-wrapper']}>
          <RoundRadioButton
            name="Select time period"
            value="time_period"
            setValue={setTimeFilter}
            selectedFilterValue={activeTimeFilter}
            filterType="time_period"
            filterItemInfo={{
              selected_time_filter: 'time_period',
              time_period: selectedPeriodValue.fullPeriod,
              displayedName: selectedPeriodValue.fullPeriod,
            }}
            buttonDisabled={!customTimeFilter}
            hasBigScreenDesign={hasBigScreenDesign}
          />
          <Link className={cx('premium-icon-badge', 'selected-time-period-icon-badge')} to="/pricing">
            <div className={Styles['premium-silver-icon-badge-container']}>
              <div className={Styles['premium-silver-icon-badge']}>
                SILVER
              </div>
              <div className={Styles['silver-tooltip']}>
                {silver ? 'This is available only to Premium subscribers' : 'Upgrade your plan to Silver to use this feature'}
              </div>
            </div>
          </Link>
        </div>
        <div className={Styles['time-select-wrapper']}>
          <div className={Styles['number-value']}>
            <span>Last</span>
            <input
              type="number"
              onKeyDown={(e) => this.removeChars(e)}
              onChange={(e) => this.setNumberTimeValue(e)}
              className={Styles['number-value-input']}
              value={selectedPeriodValue.number}
            />
          </div>
          <Dropdown
            bsPrefix={Styles['selected-time-dropdown']}
            onToggle={(status, event, source) => this.toggleDropdown(status, event, source)}
            show={dropdownOpened}
          >
            <Dropdown.Toggle id="selected-time-period">
              <span>{selectedPeriodValue.period.name}</span>
              <div className="selected-time-period-icon">
                <FontAwesomeIcon icon={dropdownOpened ? faChevronUp : faChevronDown} />
              </div>
            </Dropdown.Toggle>
            <Dropdown.Menu
              rootCloseEvent="click"
              show={dropdownOpened}
              flip={false}
              bsPrefix="dropdown-menu"
            >
              {selectedPeriodValues.map(({ value, name }, index) => (
                <Dropdown.Item
                  key={name}
                  eventKey={index}
                  active={selectedPeriodValue.name === name}
                  onSelect={() => this.setPeriodValueSelected(value, name)}
                >
                  <span>
                    {name}
                  </span>
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        </div>
        {showPeriodError && (
          <p className={Styles['period-error']}>
            Please choose a period 1 month or shorter
          </p>
        )}
        {numberValueError && (
          <p className={Styles['period-error']}>Please enter a number greater than 0.</p>
        )}
      </div>
    );
  }
}

export default withComponentName(SelectedTimePeriod);
